import React from "react";
import { motion } from "framer-motion";
import { useT } from "../i18n/LanguageContext";

export default function StatsStrip() {
  const { t } = useT();
  const STATS = [1, 2, 3, 4].map((n) => ({
    value: t(`stats.${n}.value`),
    label: t(`stats.${n}.label`),
  }));
  return (
    <section
      data-testid="stats-strip"
      className="py-16 sm:py-20 bg-[#F8F7F3] border-y border-[#BCB3A6]/30"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-12">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
          >
            <div className="font-serif text-4xl sm:text-5xl text-[#3F5043] leading-none mb-2">
              {s.value}
            </div>
            <div className="text-xs uppercase tracking-[0.2em] text-[#899480] font-semibold">
              {s.label}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
